export default "__VITE_PUBLIC_ASSET__966aa30f__"